/**
 * Enum for user statuses
 * @enum {string}
 * @readonly
 */
export const UserStatus = Object.freeze({
  ACTIVE: 'Active',
  BLOCKED: 'Blocked',
});

/**
 * Enum for user multifactor authentication statuses
 * @enum {string}
 * @readonly
 */
export const UserMultifactorStatus = Object.freeze({
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
});

/**
 * Enum for user role descriptions
 * @enum {string}
 * @readonly
 */
export const UserRoleDescriptions = Object.freeze({
  admin: 'Full access to all features and settings',
  agencyowner: 'Full access to all features and settings for an agency',
  accounting: 'Create and review statements, but cannot initiate payments',
  manager: 'Approve and pay statements',
  sales: 'View statements and transfers',
  devops: 'Internal technical user with advanced access to adjust data and API actions.',
  operations: 'Internal user who helps suppliers, fixes issues, and supports daily workflows.',
  sion_support: 'Internal read-only user who views information to help customers when needed.',
  supplierbeta: 'Beta access to limited features',
});
